import { loginWithPhone } from 'Api';
import { useMutation } from 'react-query';
import { ILoginDetails } from 'Types/Interface/IUser';

export const useLogin = () => {
	return useMutation((data: ILoginDetails) => loginWithPhone(data));
};
